import { PositiveColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

// import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';

const useStyles = createUseStyles(
  () => ({
    root: {
      boxShadow: `0 1px 0 0 ${PositiveColors.base.default}`,
      backgroundColor: PositiveColors.base.default,
      padding: [Spacings.s0, 80],
    },
    logoWrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      maxWidth: 1320,
      height: 80,
      margin: 'auto',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        justifyContent: 'center',
      },
    },
    imageContainer: {
      [canHover]: {
        '&:hover': {
          cursor: 'pointer',
        },
      },
      [canTouch]: {
        '&:active': {
          cursor: 'pointer',
        },
      },
    },
    logo: {
      width: 104,
      height: 24,
      userSelect: 'none',
    },
  }),
  {
    name: 'header',
  },
);

export default useStyles;
